import requestV2 from '@/service/request-v2'
import { normalizePageResult } from '@/service/adapters/page-result'
import type { PageQuery, PageResult } from '@/types/crud'

export interface LiveAccessStatisticsFilters {
  channelId: string | number
  consumerNickName: string
  watchTotalTime: string | number
  accessTime: string[]
}

export interface LiveAccessStatisticsRecord {
  id?: string | number
  consumerNickName: string
  consumerHeadImgUrl: string
  channelName: string
  deptName: string
  empName: string
  totalDuration: number
}

export interface LiveAccessStatisticsChannel {
  rowId: string | number
  eventName: string
}

function buildParams(query: PageQuery<LiveAccessStatisticsFilters>) {
  return {
    ...query.filters,
    pageNo: query.pageNo,
    pageSize: query.pageSize,
    ...(query.sort
      ? { orderBy: query.sort.prop, orderType: query.sort.order }
      : {})
  }
}

async function requireExportFile(blob: Blob) {
  if (!blob.type.includes('application/json')) return blob
  const payload = JSON.parse(await blob.text()) as { message?: string }
  throw new Error(payload.message || '导出失败')
}

export async function fetchLiveAccessStatisticsPage(
  query: PageQuery<LiveAccessStatisticsFilters>,
  signal: AbortSignal
): Promise<PageResult<LiveAccessStatisticsRecord>> {
  const payload = await requestV2.get<unknown>({
    url: '/main/liveAccessStatistics/queryByCondition',
    params: buildParams(query),
    signal
  })
  return normalizePageResult<LiveAccessStatisticsRecord>(payload)
}

export async function fetchLiveAccessStatisticsFilterOptions(): Promise<
  LiveAccessStatisticsChannel[]
> {
  const payload = await requestV2.get<unknown>({
    url: '/main/customerEvents/queryByCondition',
    params: { pageNo: 1, pageSize: 1000 }
  })
  return normalizePageResult<LiveAccessStatisticsChannel>(payload).records
}

export function exportLiveAccessStatistics(
  query: PageQuery<LiveAccessStatisticsFilters>
) {
  return requestV2
    .get<Blob>({
      url: '/main/liveAccessStatistics/download',
      params: buildParams(query),
      responseType: 'blob'
    })
    .then(requireExportFile)
}
